import { createReducer } from '@reduxjs/toolkit';

import actions from './actions';
import operations from './operations';

type GPSLocationState = {
  readonly latitude: number;
  readonly longitude: number;
  readonly zoom: number;
}

// santa clara data center
const initialState: GPSLocationState = {
  latitude: 37.3894698,
  longitude: -121.9643038,
  zoom: 9,
};

const gpsLocationReducer = createReducer(initialState, (builder) => {
  builder.addCase(actions.resetGPSLocation, (draft) => {
    draft.latitude = initialState.latitude;
    draft.longitude = initialState.longitude;
    draft.zoom = initialState.zoom;
  });

  builder.addCase(actions.changeGPSLocation, (draft, { payload }) => {
    draft.latitude = payload.latitude ?? draft.latitude;
    draft.longitude = payload.longitude ?? draft.longitude;
    draft.zoom = payload.zoom ?? draft.zoom;
  });

  builder.addCase(operations.submitGPSLocation.fulfilled, (draft, { payload }) => {
    draft.latitude = payload.latitude;
    draft.longitude = payload.longitude;
  });
});

export default gpsLocationReducer;
export {
  GPSLocationState,
  initialState,
};
